import * as styles from "./AlertDialogTitle.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { AlertDialog as BaseAlertDialog } from "@base-ui/react/alert-dialog";

import type { AlertDialogTitleProps } from "./AlertDialog.types";

export function AlertDialogTitle({
  className,
  ...props
}: AlertDialogTitleProps): JSX.Element {
  return (
    <BaseAlertDialog.Title
      data-slot="alert-dialog-title"
      className={clsx(styles.title, className)}
      {...props}
    />
  );
}
